import React, { Component } from 'react';
import { Route, BrowserRouter} from 'react-router-dom';
import './../node_modules/antd/dist/antd.min.css';
import Home from './components/layouts/Home';
import Auth from './components/layouts/Auth';
import Layout from './components/layouts/Layout';


import { Provider } from 'react-redux';
import store from './stores/store';


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Layout>
            <Route exact path="/" component={Home} />
            <Route exact path="/auth" component={Auth} />
            <Route exact path="/auth/:auth_key" component={Auth} />
          </Layout>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js